import React, { forwardRef } from 'react';

import { Typography } from '@mui/material';
import { styled } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Link } from 'react-router-dom';

import TestIcon from '~/assets/icons/TestIcon';
import { ITestCard } from '~/pages/const';
import { SMALL_RADIUS_PX, TINY_MARGIN_PX } from '~/theme';

const TestCard = forwardRef<HTMLAnchorElement, ITestCard>(
  ({ canPass, caption, link, ...rest }, ref) => {
    return (
      <StyledLink
        {...rest}
        as={canPass && link ? Link : Div}
        ref={ref}
        to={link || ''}
        data-testid="quizCard"
      >
        <Preview data-testid="quizPreview" canPass={canPass}>
          <StyledTestIcon canPass={canPass} />
        </Preview>
        <Title data-testid="quizTitle">{caption}</Title>
      </StyledLink>
    );
  },
);

export default TestCard;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.palette.common.text.secondaryToPrimary};
  &:hover {
    color: ${({ theme }) => theme.palette.common.accent};
  }
`;
const Div = styled('div', {
  shouldForwardProp: (prop) => prop !== 'to',
})``;
const Preview = styled('div', {
  shouldForwardProp: (prop) => prop !== 'canPass',
})<{ canPass: boolean }>`
  position: relative;
  height: 82px;
  margin-bottom: ${TINY_MARGIN_PX};
  border-radius: ${SMALL_RADIUS_PX};
  border: 1px solid
    ${({ canPass, theme }) =>
      canPass ? theme.palette.common.primary : alpha(theme.palette.common.card.border, 0.4)};
  background: ${({ theme }) => theme.palette.common.quiz.bg};
`;
const StyledTestIcon = styled(TestIcon, {
  shouldForwardProp: (prop) => prop !== 'canPass',
})`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;

  & path {
    fill: ${({ canPass, theme }) =>
      canPass ? theme.palette.common.primary : alpha(theme.palette.common.card.border, 0.4)};
  }
`;
const Title = styled(Typography)`
  font-size: 12px;
  line-height: 12px;
  color: inherit;
  transition: 0.3s color;
`;
